var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"advertising radius-box-8 padding-box-16"},[_c('div',{staticClass:"ad"},[_vm._v("Espacio Publicitario")])])
}]

export { render, staticRenderFns }